/** @jsx jsx */
import { useEffect, useRef, useState } from 'react'
import { Box, Flex, jsx } from 'theme-ui'

import Text from '~/components/IntlComponents/Text'
import { LinkWrapper } from '~/components/Product/Page/LinkWrapper'
import useWindowSize from '~/hooks/components/use-window-size'

const Sublink = ({
  children,
  secondary = false,
  slug,
  tagList,
  contenttype,
  forwardSx = {},
  ...props
}) => {
  const windowSize = useWindowSize()
  const linkWidthref = useRef(null)
  const [linkTextWidth, setLinkTextWidth] = useState(null)
  const TaglineList = tagList => {
    if (tagList && tagList.length) {
      return tagList.map(tag => {
        const [title, color] = tag.split('|')
        return (
          <Text
            key={title + ' - ' + color}
            sx={{
              padding: '4px 8px',
              fontSize: '12px',
              fontFamily: 'body',
              background: color,
              borderRadius: '8px',
              mr: '0.5rem',
              mt: '0.5rem',
              height: 'fit-content',
              minWidth: 'fit-content',
            }}
          >
            {title}
          </Text>
        )
      })
    }
    return null
  }

  useEffect(() => {
    if (!windowSize) return
    setLinkTextWidth(
      linkWidthref.current?.clientWidth > 240
        ? '15ch'
        : `${children.split('').length > 12 ? '10ch' : '8vw'}`,
    )
  }, [children, windowSize])
  return (
    <LinkWrapper slug={slug} contenttype={contenttype} {...props}>
      <div
        ref={linkWidthref}
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontFamily: ['body', 'heading'],
          cursor: 'pointer',
          fontSize: ['18px', null, '20px'],
          textDecoration: secondary && [null, 'underline'],
          ...forwardSx,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            isolation: 'isolate',
            minWidth: '10ch',
            maxWidth: ['15ch', '10ch', linkTextWidth],
          }}
        >
          <Text sx={{}}>{children}</Text>
        </Box>
        <Flex
          sx={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            mt: '-0.5rem',
            ml: '0.5rem',
            textAlign: 'center',
          }}
        >
          {TaglineList(tagList)}
        </Flex>
      </div>
    </LinkWrapper>
  )
}

export default Sublink
